import {Component, Input} from '@angular/core';
import {faInfoCircle} from '@fortawesome/pro-regular-svg-icons';
import {Feature} from '@webmate-web-core/shared/types/feature';
import {Popover} from 'primeng/popover';

@Component({
    selector: 'wm-internal-support',
    templateUrl: 'internal-support.component.html',
    styleUrls: ['./internal-support.component.less']
})
export class InternalSupportComponent {
    @Input() feature: Feature;
    label: string;
    links: [{ label: string; url: string }];
    icon = faInfoCircle;

    ngOnInit() {
        this.label = this.feature['label'];
        this.links = this.feature['links'];
    }

    navigateTo(op: Popover, url: string) {
        op.hide();
        window.open(url);
    }
}
